import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Eyebrow } from "@/components/ui-bits";
import { FAQS } from "@/data/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <>
      <Seo title="FAQ — EI Battery Solutions" description="Frequently asked questions about EI Battery Solutions wholesale supply, delivery, warranty and pricing." />
      <section className="bg-ei-navy text-ei-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <Eyebrow className="text-ei-gold">Answers for the trade</Eyebrow>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight">Frequently asked questions</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16 lg:py-24">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-ei-mist">
              <AccordionTrigger className="text-left font-display font-semibold text-ei-navy hover:text-ei-golddark hover:no-underline py-5" data-testid={`faq-question-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-ei-graphite/85 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center bg-white border border-ei-mist rounded-md p-8">
          <h2 className="text-xl font-semibold text-ei-navy">Still have a question?</h2>
          <p className="mt-2 text-sm text-ei-graphite/80">Our sales team is happy to help with trade enquiries.</p>
          <Link to="/request-a-quote" className="mt-5 inline-flex font-display text-sm font-bold bg-ei-navy text-ei-white px-6 py-3.5 rounded-sm hover:bg-ei-ink min-h-[44px] items-center" data-testid="faq-quote-cta">
            Request a quote
          </Link>
        </div>
      </section>
    </>
  );
}
